import React from 'react';
import { Cloud, RefreshCw, GitBranch, Shield, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

export const Services = () => {
  const services = [
    {
      icon: Cloud,
      title: 'Cloud Infrastructure',
      description: 'Comprehensive cloud solutions on AWS and Azure. From migration to optimization, we design scalable, cost-effective architectures that grow with your business.',
      image: 'https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjbG91ZCUyMGNvbXB1dGluZ3xlbnwwfHx8fDE3NjI0Mjc2ODJ8MA&ixlib=rb-4.1.0&q=85',
      features: ['AWS & Azure Certified', 'Infrastructure as Code', 'Cost Optimization', 'Multi-Cloud Strategy']
    },
    {
      icon: RefreshCw,
      title: 'DevOps Automation',
      description: 'Streamline your development lifecycle with modern DevOps practices. Automate deployments, reduce manual errors, and accelerate time-to-market.',
      image: 'https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxhdXRvbWF0aW9ufGVufDB8fHx8MTc2MjMzODU0MXww&ixlib=rb-4.1.0&q=85',
      features: ['Automated Workflows', 'Container Orchestration', 'Monitoring & Logging', 'Infrastructure Automation']
    },
    {
      icon: GitBranch,
      title: 'CI/CD Pipelines',
      description: 'Implement robust continuous integration and delivery pipelines. Enable your teams to ship code faster and more reliably with automated testing and deployment.',
      image: 'https://images.pexels.com/photos/171198/pexels-photo-171198.jpeg',
      features: ['Jenkins, GitLab, GitHub Actions', 'Automated Testing', 'Blue-Green Deployments', 'Rollback Strategies']
    },
    {
      icon: Shield,
      title: 'Security & Compliance',
      description: 'Protect your infrastructure with enterprise-grade security solutions. We implement security best practices across your entire technology stack.',
      image: 'https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg',
      features: ['Security Audits', 'Compliance Management', 'Identity & Access Control', 'Vulnerability Scanning']
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 md:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            End-to-end IT solutions designed to transform your infrastructure and accelerate your digital transformation journey.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="overflow-hidden hover:shadow-xl transition-shadow duration-300 border-0">
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>
                <div className="absolute bottom-4 left-4 flex items-center space-x-3">
                  <div className="bg-blue-600 p-3 rounded-lg">
                    <service.icon className="text-white" size={24} />
                  </div>
                  <h3 className="text-2xl font-bold text-white">{service.title}</h3>
                </div>
              </div>
              <CardContent className="p-6">
                <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <ArrowRight className="text-blue-600 mr-2 flex-shrink-0" size={16} />
                      {feature}
                    </li>
                  ))}
                </ul>
                <Button
                  variant="outline"
                  className="w-full border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white"
                  onClick={scrollToContact}
                >
                  Learn More
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};